export default class RandomIMG {
  constructor(el) {
    this.el = el;
    this.init();
  }

  /* eslint-disable class-methods-use-this */
  init() {
    const numImg = Number.parseInt(this.el.getAttribute('data-numImg'), 10);
    const { path, fileNameInit } = this.mapPath(this.el.getAttribute('src'));
    const fileName = this.randomizeImg(fileNameInit, numImg);

    this.setImg(path, fileName);
  }

  setImg(path, fileName) {
    this.el.setAttribute('src', `${path}/${fileName}`);
  }

  randomizeImg(fileNameInit, numImg) {
    const [fileName, fileExtension] = fileNameInit.split('.');
    const fileNameBase = fileName.slice(0, -1);
    const num = this.randomIntFromInterval(1, numImg);

    return `${fileNameBase}${num}.${fileExtension}`;
  }

  mapPath(fullPath) {
    const pathParts = fullPath.split('/');
    const fileNameInit = pathParts.pop();
    const pathClean = pathParts.filter(Boolean);
    const path = `/${pathClean.join('/')}`;

    return {
      path,
      fileNameInit
    };
  }

  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/random_img.js